import React from 'react';
import { Collapse, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import cls from 'classnames';
import {
    FormCheckbox, FormLabel, FlexRow,
} from '../common/forms/FormElements';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import SlideForm from '../common/forms/SlideForm';
import CommonContext from '../Common';
import NumericInput from '../common/forms/NumericInput';
import Input from 'components/common/forms/Input';
import { TipAlert } from '../common/TipAlert';

export default class ChargeTypeConfigurationForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            loading: true,
            errors: {},
            formValidated: false,
            validationMessage: '',
            isValidated: false,
        };
    }

    componentDidMount() {
        this.populateState();
    }

    onClose = (response) => {
        this.resetForm();
        this.context.setFormOpened(false);
        this.props.onClose(response);
    };

    onSubmit = (e) => {
        this.context.setFormOpened(false);
        this.props.onSaveCallback();
    };
    onRemove = (e) => {
        this.context.setFormOpened(false);
        this.props.onRemoveCallback();
    };
    async populateState() {
        this.setState((state) => ({
            loading: false,
        }));
    }

    resetForm = () => this.setState({ formValidated: false, errors: {} });

    render() {
        if (!this.props.entity) return '';
        const { entity, hasHourlyEquipment, surcharges } = this.props;
        const name = (this.props.entityName ? `${this.props.entityName}.` : '');
        const unitsName = this.props.entity.unitsId ? (this.props.entity.unitsId === 1 ? 'Hours' : 'Units') : '';

        return (
            <SlideForm
                loading={this.state.loading}
                show={this.props.show}
                id="chargeTypeConfigForm"
                formIcon={faMinusCircle}
                formTitle={!this.props.isNewException ? 'Edit Exception' : 'Add Exception'}
                ref={this.formRef}
                setIsValidated={(value) => {
                    this.setState({ formValidated: value });
                }}
                isValidated={this.state.formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                errors={this.state.errors}
                onClearErrors={this.onClearErrors}
                validationMessage={this.state.validationMessage}
                showDelete={!this.props.isNewException}
                onDelete={this.onRemove}
            >
                <>
                    <FormGroup>
                        <FormLabel text="Customers" />
                        <ValidatedSelect
                            name={`${name}customers`}
                            isMulti
                            required
                            options={this.props.customers}
                            value={(this.props.customers ?? []).filter((x) => (entity.customers ?? []).includes(x.value)) ?? ''}
                            onChange={this.props.onSelectChange}
                            validationMessage="At least one group selection is required."
                        />
                    </FormGroup>
                    <FormGroup>
                        <FormLabel text="Applicable Charge?" />
                        <FormCheckbox
                            id={`${name}doesNotApply`}
                            className="ml-3"
                            checked={entity.doesNotApply ?? ''}
                            onChange={this.props.onDoesNotApplyChanged}
                            labelText="Does Not Apply"
                        />
                    </FormGroup>

                    {!entity.doesNotApply
                        && (
                            <>
                                {this.props.chargeUnitId == 1 && (
                                    <>
                                        <FormGroup>
                                            <FormLabel
                                                text="Increment"
                                                required={this.props.requireIncrement}
                                            />

                                            <ValidatedSelect
                                                name={`${name}increment`}
                                                required={this.props.requireIncrement}
                                                options={this.props.increments}
                                                value={this.props.increments.find((i) => i.value == entity.increment) ?? ''}
                                                onChange={this.props.onSelectChange}
                                                validationMessage="Increment is required."
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <FormLabel text="Break Options" />
                                            <FlexRow className="ml-3">
                                                <FormCheckbox
                                                    id={`${name}canBreak`}
                                                    name={`${name}canBreak`}
                                                    checked={entity.canBreak ?? ''}
                                                    onChange={this.props.onCanBreakChanged}
                                                    labelText="Enable Breaks"
                                                />
                                                <FontAwesomeIcon icon={faChevronRight} className="ml-2 mr-2" />
                                                <FormCheckbox
                                                    id={`${name}paidBreak`}
                                                    name={`${name}paidBreak`}
                                                    disabled={!entity.canBreak}
                                                    checked={entity.paidBreak ?? ''}
                                                    onChange={this.props.onChange}
                                                    labelText="Paid Break"
                                                />
                                            </FlexRow>
                                        </FormGroup>

                                        <Input
                                            label="Break Description"
                                            name={`${name}breakDescription`}
                                            value={entity.breakDescription ?? ''}
                                            onChange={this.props.onChange}
                                            placeholder="Break description"
                                            required={!!entity.canBreak}
                                            formGroupClassName={cls('ml-3', { 'opacity-half': !entity.canBreak })}
                                            error="Description is required."
                                        />

                                        {!entity.isSurcharge && (
                                            <>
                                                <FormGroup>
                                                    <FormCheckbox
                                                        id={`${name}addSurchargeIfMissedBreak`}
                                                        name={`${name}addSurchargeIfMissedBreak`}
                                                        disabled={!entity.canBreak}
                                                        checked={entity.addSurchargeIfMissedBreak ?? ''}
                                                        onChange={this.props.onChange}
                                                        labelText="Add Surcharge If Break Is Missed"
                                                        className="ml-3"
                                                    />
                                                </FormGroup>

                                                <Collapse isOpen={!!entity.addSurchargeIfMissedBreak}>
                                                    <div className="ml-3">
                                                        <TipAlert
                                                            tipText="Note"
                                                            label="A surcharge will only be added for missed lunch breaks if the employee works for at least a number of hours equal to the below threshold."
                                                        />

                                                        <NumericInput
                                                            label="Missed Lunch Break Hours Threshold"
                                                            name={`${name}missedBreakHoursThreshold`}
                                                            required={Boolean(entity.addSurchargeIfMissedBreak)}
                                                            value={entity.missedBreakHoursThreshold ?? ''}
                                                            onChange={this.props.onChange}
                                                            step="0.25"
                                                            min={0}
                                                            error="A work hour threshold is required."
                                                        />

                                                        <FormGroup>
                                                            <FormLabel
                                                                text="Surcharge to Add On Missed Break"
                                                                required={Boolean(entity.addSurchargeIfMissedBreak)}
                                                            />

                                                            <ValidatedSelect
                                                                name={`${name}childChargeTypeId`}
                                                                id={`${name}childChargeTypeId`}
                                                                isClearable
                                                                required={Boolean(entity.addSurchargeIfMissedBreak)}
                                                                options={surcharges}
                                                                value={
                                                                    (surcharges ?? []).find(
                                                                        (x) => x.value === entity.childChargeTypeId,
                                                                    ) ?? ''
                                                                }
                                                                onChange={this.props.onSelectChange}
                                                                validationMessage="A surcharge selection is required."
                                                            />

                                                        </FormGroup>
                                                    </div>
                                                </Collapse>
                                            </>
                                        )}

                                        <NumericInput
                                            label="Minimum Pay"
                                            name={`${name}minimumPayUnits`}
                                            required={!!entity.minimumPayUnits}
                                            value={entity.minimumPayUnits ?? ''}
                                            onChange={this.props.onChange}
                                            placeholder={`Enter ${unitsName}`}
                                            step="0.25"
                                            error="Minimum Pay is required."
                                        />
                                        <NumericInput
                                            label="Maximum Pay"
                                            name={`${name}maximumPayUnits`}
                                            required={!!entity.maximumPayUnits}
                                            value={entity.maximumPayUnits ?? ''}
                                            onChange={this.props.onChange}
                                            placeholder={`Enter ${unitsName}`}
                                            step="0.25"
                                            error="Maximum Pay is required."
                                        />
                                        <NumericInput
                                            label="Minimum Bill"
                                            name={`${name}minimumBillUnits`}
                                            required={!!entity.minimumPayUnits}
                                            value={entity.minimumBillUnits ?? ''}
                                            onChange={this.props.onChange}
                                            placeholder={`Enter ${unitsName}`}
                                            step="0.25"
                                            error="Minimum Bill is required."
                                        />
                                        <NumericInput
                                            label="Maximum Bill"
                                            name={`${name}maximumBillUnits`}
                                            required={!!entity.maximumPayUnits}
                                            value={entity.maximumBillUnits ?? ''}
                                            onChange={this.props.onChange}
                                            placeholder={`Enter ${unitsName}`}
                                            step="0.25"
                                            error="Maximum Bill is required."
                                        />
                                    </>
                                )}

                                {this.props.chargeUnitId == 2 && (
                                    <>
                                        <NumericInput
                                            label="Increment"
                                            name={`${name}increment`}
                                            required={this.props.requireIncrement}
                                            value={entity.increment ?? ''}
                                            onChange={this.props.onChange}
                                            placeholder={`Enter ${unitsName}`}
                                            step="0.25"
                                            error="Increment is required."
                                        />
                                        <NumericInput
                                            label="Minimum Bill"
                                            name={`${name}minimumBillUnits`}
                                            required={!!entity.minimumPayUnits}
                                            value={entity.minimumBillUnits ?? ''}
                                            onChange={this.props.onChange}
                                            placeholder={`Enter ${unitsName}`}
                                            step="0.25"
                                            error="Minimum Bill is required."
                                        />
                                        <NumericInput
                                            label="Maximum Bill"
                                            name={`${name}maximumBillUnits`}
                                            required={!!entity.maximumPayUnits}
                                            value={entity.maximumBillUnits ?? ''}
                                            onChange={this.props.onChange}
                                            placeholder={`Enter ${unitsName}`}
                                            step="0.25"
                                            error="Maximum Bill is required."
                                        />
                                    </>
                                )}
                                <FormGroup>
                                    <FormLabel
                                        text="Timesheet Options"
                                    />
                                    <FormCheckbox
                                        className="ml-3"
                                        id={`${name}disallowNA`}
                                        name={`${name}disallowNA`}
                                        checked={entity.disallowNA ?? ''}
                                        onChange={this.props.onChange}
                                        labelText="Require Data Entry on Timesheet (Do not allow N/A reply)"
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <FormLabel text="Cancellation Options" />
                                    {(this.props.tenantSettings ?? {}).blockBillingCancelEnabled && (
                                        <FormGroup>
                                            <FlexRow className="ml-3">
                                                <FormCheckbox
                                                    id={`${name}blockBillingCancel`}
                                                    name={`${name}blockBillingCancel`}
                                                    checked={entity.blockBillingCancel ?? ''}
                                                    onChange={this.props.onChange}
                                                    labelText="Block Cancellation if Min Bill Qty Charge > 0 for Billing"
                                                />
                                            </FlexRow>
                                        </FormGroup>
                                    )}
                                    {(this.props.tenantSettings ?? {}).blockPayrollCancelEnabled && (
                                        <FormGroup>
                                            <FlexRow className="ml-3">
                                                <FormCheckbox
                                                    id={`${name}blockPayrollCancel`}
                                                    name={`${name}blockPayrollCancel`}
                                                    checked={entity.blockPayrollCancel ?? ''}
                                                    onChange={this.props.onChange}
                                                    labelText="Block Cancellation if Min Pay Qty Charge > 0 for Payroll"
                                                />
                                            </FlexRow>
                                        </FormGroup>
                                    )}
                                </FormGroup>
                                <NumericInput
                                    formGroupClassName="ml-3"
                                    label="Cancellation Time Threshold (Min)"
                                    id={`${name}cancellationTimeThreshold`}
                                    name={`${name}cancellationTimeThreshold`}
                                    value={entity.cancellationTimeThreshold ?? ''}
                                    onChange={this.props.onChange}
                                    placeholder="Enter Time in Minutes"
                                    step="1"
                                    required={!!entity.canBreak}
                                />
                                <NumericInput
                                    formGroupClassName="ml-3"
                                    label={`Minimum Cancellation Bill Qty (${this.props.chargeUnitId == 1 ? 'Hours' : 'Flat'})`}
                                    id={`${name}cancellationBillQty`}
                                    name={`${name}cancellationBillQty`}
                                    value={entity.cancellationBillQty ?? ''}
                                    onChange={this.props.onChange}
                                    placeholder={`Enter Qty ${this.props.chargeUnitId == 1 ? 'in Hours' : 'Flat'}`}
                                    step=".025"
                                    required={!!entity.canBreak}
                                />
                                <FormGroup>
                                    <FormLabel
                                        text="Invoicing"
                                    />
                                    <FormCheckbox
                                        id={`${name}omitFromInvoice`}
                                        name={`${name}omitFromInvoice`}
                                        className="ml-3"
                                        checked={entity.omitFromInvoice ?? ''}
                                        onChange={this.props.onChange}
                                        labelText="Omit from Charge Details on Invoice"
                                    />
                                </FormGroup>

                                {hasHourlyEquipment && (
                                    <FormGroup>
                                        <FormLabel
                                            text="Hourly Equipment"
                                        />
                                        <FormCheckbox
                                            id={`${name}hourlyEquipmentOvertime`}
                                            name={`${name}hourlyEquipmentOvertime`}
                                            className="ml-3"
                                            checked={
                                                entity.hourlyEquipmentOvertime ?? false
                                            }
                                            onChange={this.props.onChange}
                                            labelText="Overtime applies to hourly equipment charge"
                                        />
                                    </FormGroup>
                                )}
                            </>
                        )}
                </>
            </SlideForm>
        );
    }
}
